import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import styles from "./index.module.scss";
import separatorIco from "./assets/separator_ico.png";
import User from "@/app/csr-src/assets/icons/User.svg";
import Image from "next/image";

interface breadCrumbProps {
  list: Array<{
    name: string;
    url?: string;
  }>;
}

const breadCrumb: React.FC<breadCrumbProps> = observer(({ list }) => {
  const navigate = useNavigate();
  if (!list.length) {
    return null;
  }
  const handleClick = (url: string | undefined) => {
    url && navigate(url);
  };
  return (
    <div className={styles.wrap}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<Image src={separatorIco} className={styles.separator_ico} alt="separator" />}
        className={styles.breadcrumbs_wrap}
      >
        {list[0] ? (
          <Link
            underline="none"
            style={list[0].url ? { cursor: "pointer" } : {}}
            color="inherit"
            onClick={() => handleClick(list[0].url)}
          >
            <div className={styles.item_wrap}>
              <User className={styles.item_icon} />
              {/* <i className={styles.item_icon}></i> */}
              {list[0].name}
            </div>
          </Link>
        ) : null}
        {list[1] ? (
          <Link
            underline="none"
            style={list[1].url ? { cursor: "pointer" } : {}}
            color={list.length - 1 === 1 ? "rgba(26, 26, 26, 1)" : "inherit"}
            onClick={() => handleClick(list[1].url)}
          >
            {list[1].name}
          </Link>
        ) : null}
        {list[2] ? (
          <Link
            underline="none"
            style={list[2].url ? { cursor: "pointer" } : {}}
            color={list.length - 1 === 2 ? "text.primary" : "inherit"}
            onClick={() => handleClick(list[2].url)}
            aria-current="page"
          >
            {list[2].name}
          </Link>
        ) : null}
      </Breadcrumbs>
    </div>
  );
});

export default breadCrumb;
